import { Form, Card, CardBody } from "react-bootstrap";
import { useForm, FormProvider, useFieldArray } from "react-hook-form";
import { Input, PageWrapper } from "../../components";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { getAttempDetail } from "../../api/attemp";
import { FaCheck } from "react-icons/fa";
import { Header } from "../../components";

const AttempDetail = ({ }) => {
    const quizQuestionName = "quizQuestions"
    const { t } = useTranslation()
    const form = useForm({
        defaultValues: {
            isPublish: true
        }
    })
    const { fields } = useFieldArray({ control: form.control, name: quizQuestionName });
    const { id } = useParams()
    useEffect(() => {
        getData()
    }, [])

    const getData = async () => {
        const response = await getAttempDetail(id)
        form.reset(response)
    }

    return <PageWrapper headerProps={{ title: "ATTEMPT_DETAIL" }}>
        <FormProvider {...form}>
            <Form>
                <Input label={t("TOTAL_QUESTION")} name={"totalQuestions"} formControlProps={{ disabled: true }} />
                <Input label={t("CORRECT_ANSWER_COUNT")} name={"correctAnswersCount"} formControlProps={{ disabled: true }} />
                <Input label={t("SCORE")} name={"score"} formControlProps={{ disabled: true }} />
                <Input label={t("USER")} name={"user.fullName"} formControlProps={{ disabled: true }} />
                {
                    fields.map((field, index) =>
                        <Card className={"mb-4"}>
                            <Card.Header as={"h6"} className="p-3">
                                Question {index + 1}: <b>{field?.quizId?.question}</b>
                            </Card.Header>
                            <CardBody>
                                {field?.quizId?.options.map((e, index) =>
                                    <div className={`border rounded d-flex justify-content-between align-items-center p-3 ${index < field?.quizId?.options.length - 1 && "mb-3"}`} style={{ background: e.isCorrect ? "#a9dfbf" : e.id === field.optionId ? "#e6b0aa" : "" }}>
                                        {e.optionText}
                                        {field?.optionId === e.id && e.isCorrect && <FaCheck />}
                                    </div>
                                )}
                            </CardBody>
                        </Card>
                    )
                }
            </Form>
        </FormProvider>
    </PageWrapper>
}

export default AttempDetail;